import React, { useState, useCallback } from "react";
import useAuth from "../../Hooks/useAuth";
import usePermission from "../../Hooks/usePermission";
import { useLazySearchUsersQuery } from "../../store";
import UserListWithSearch from "../../Components/Table/UserListWithSearch";
import {
  UserCreateDrawer,
} from "../../Components/Utils/UserDrawer";
import { PageShell } from "../../Components/shared";

function UsersPage() {
  const { auth } = useAuth();
  const { hasPermission, hasAnyPermission, isAdmin } = usePermission();
  const token = auth.accessToken;

  // Drawer state
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  // Server-side search
  const [searchUsers, { data: searchResult, isFetching, isLoading }] =
    useLazySearchUsersQuery();

  const handleSearch = useCallback(
    ({ search, name, email, firmName, subRole, role, page, limit }) => {
      if (token) {
        searchUsers({ token, search, name, email, firmName, subRole, role, page, limit });
      }
    },
    [token, searchUsers]
  );

  const handleCreateClose = useCallback(() => setIsCreateOpen(false), []);

  const users = searchResult?.data?.users || [];
  const total = searchResult?.data?.total || 0;
  const totalPages = searchResult?.data?.totalPages || 1;
  const currentServerPage = searchResult?.data?.page || 1;

  return (
    <PageShell>
      <div className="overflow-hidden flex-1 min-h-0 flex flex-col">
        <UserListWithSearch
          data={users}
          total={total}
          totalPages={totalPages}
          currentServerPage={currentServerPage}
          isLoading={isLoading || isFetching}
          canViewUserDetail={hasPermission("users.detail")}
          onAddNew={hasAnyPermission("users.createStorage", "users.createDealer", "users.createCustomer", "users.createEnduser", "users.createMachineworker") ? () => setIsCreateOpen(true) : undefined}
          onSearch={handleSearch}
          token={token}
          onRefetch={handleSearch}
          isAdmin={isAdmin}
          hasPermission={hasPermission}
        />
      </div>

      {/* Create drawer */}
      <UserCreateDrawer
        open={isCreateOpen}
        onClose={handleCreateClose}
        token={token}
        refetch={() => handleSearch({ search: "", role: "all", page: 1, limit: 10 })}
      />
    </PageShell>
  );
}

export default UsersPage;
